const showClass = "show";

function trapFocus(element) {
	const focusableElements = element.querySelectorAll('a, button');
	const toggle = focusableElements[0];
	const lastOption = focusableElements[focusableElements.length - 1];

	function handleKeydown(e) {
		const itemParent = toggle.parentNode;
		const dropdownMenu = itemParent.querySelector('.dropdown-menu');
		const isTab = e.key === 'Tab' || e.keyCode === 9;

		if (!isTab || (dropdownMenu && !dropdownMenu.classList.contains(showClass))) return;

		if (e.shiftKey && document.activeElement === toggle) {
			lastOption.focus();
			e.preventDefault();
		} else if (!e.shiftKey && document.activeElement === lastOption) {
			toggle.focus();
			e.preventDefault();
		}
	}

	element.addEventListener('keydown', handleKeydown);

	return () => {
		element.removeEventListener('keydown', handleKeydown);
	};
}

function getNextFocusableElement(element) {
	var sibling = element.nextElementSibling;
	while (sibling) {
		if(sibling.getAttribute('id') === 'clearview-button') {
			return sibling.querySelector('#clearview-button');
		} else if (sibling.getAttribute('tabindex') === '0') {
			return sibling;
		}
		
		sibling = sibling.nextElementSibling;
	}

	return null;
}

export { trapFocus, getNextFocusableElement }